import { Injectable } from '@angular/core';
import { EntityDto, Rest, RestService } from '@ralba/shared';
import {
  CreateGeneralArtifactInputDto,
  GeneralArtifactDto,
  TenancyRequestDto,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class EmployeeGeneralArtifactHttpApiService {
  constructor(private rest: RestService) {}

  public create(body: TenancyRequestDto<CreateGeneralArtifactInputDto>) {
    const request: Rest.Request<
      TenancyRequestDto<CreateGeneralArtifactInputDto>
    > = {
      method: 'POST',
      url: '/api/employee/general-artifact/create',
      body,
    };
    return this.rest.request<
      TenancyRequestDto<CreateGeneralArtifactInputDto>,
      Rest.AbpResponse<number>
    >(request);
  }

  public get(params: TenancyRequestDto<EntityDto>) {
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/employee/general-artifact/get',
      params,
    };
    return this.rest.request<null, Rest.AbpResponse<GeneralArtifactDto>>(
      request
    );
  }

  public setOpenState(body: TenancyRequestDto<EntityDto>) {
    const request: Rest.Request<TenancyRequestDto<EntityDto>> = {
      method: 'PUT',
      url: '/api/employee/general-artifact/set-open-state',
      body,
    };
    return this.rest.request<
      TenancyRequestDto<EntityDto>,
      Rest.AbpResponse<GeneralArtifactDto>
    >(request);
  }

  public setClosedState(body: TenancyRequestDto<EntityDto>) {
    const request: Rest.Request<TenancyRequestDto<EntityDto>> = {
      method: 'PUT',
      url: '/api/employee/general-artifact/set-closed-state',
      body,
    };
    return this.rest.request<
      TenancyRequestDto<EntityDto>,
      Rest.AbpResponse<GeneralArtifactDto>
    >(request);
  }
}
